import type { ReactNode } from "react"
import type { CurrentUser } from "../types"
interface AuthContextValue {
  currentUser: CurrentUser | null
  loading: boolean
  login: (user: CurrentUser) => void
  logout: () => void
}
import { createContext, useContext, useState, useEffect } from "react"
import { getCurrentUser } from "../api/auth"

const AuthContext = createContext<AuthContextValue | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    void getCurrentUser()
      .then((user) => {
        if (active) setCurrentUser(user)
      })
      .catch(() => {
        if (active) setCurrentUser(null)
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [])

  function login(user: CurrentUser) {
    setCurrentUser(user)
  }

  function logout() {
    setCurrentUser(null)
  }

  return (
    <AuthContext.Provider value={{ currentUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) throw new Error("AuthProvider is required")
  return context
}
